import TasksCollection from "../task/collection"
import Task from "../task/task"
import ProjectSession from "../project/project-session"
import ApiUDS from "../../gd/api/universal-data-selector"
import {InternalDBState} from "./@const"

type InternalDatabase_Config = {
    id      : ID // project id,
    items   : Task[]
}

// const debug = "InternalDatabase"
const debug = false

export default class InternalDatabase {

    public project  : ProjectSession

    public tasks    : TasksCollection = new TasksCollection([])

    public state    : InternalDBState = InternalDBState.NOT_LOADED

    constructor(project : ProjectSession) {
        this.project = project
    }

    get id():ID {
        return this.project.id
    }

    get isLoaded():boolean {
        return this.state === InternalDBState.LOADED
    }

    load() {
        debug && console.log(debug, 'load', this.isLoaded, this.state)

        if (this.isLoaded) {
            return
        }

        if (this.state === InternalDBState.LOADING) {
            return
        }

        this.loadDBData()
    }

    private async loadDBData() {

        const response = await ApiUDS.loadInternalDatabaseTasks([this.project.id]).promise()

        gd.bus.triggerEvent('DB-XXX Loaded...')

    }

    // toJSON() {
    //     return {
    //         id      : this.id,
    //         items   : this.items
    //     }
    // }

    public toOptions():Options {

        return _.map(this.tasks?.models, (task: Task) => {
            return {
                value   : task.id,
                label   : task.name,
                color   : undefined
            }
        })
    }
}
